import { mutate } from 'swr'

import {
  fetchFile,
  postJson,
  putJson,
  requestDelete,
  requestDeleteBatchWithBody,
} from '../../../../../data/fetchers'
import { CompanyCode, CompanyCodeCustomField } from '../../suppliers/data'

export async function requestCreateCompanyCode(companyCode: CompanyCode) {
  await postJson('/masterdata/companycodes', companyCode)

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith('/masterdata/companycodes'.toLowerCase()),
  )
}

export async function requestUpdateCompanyCode(
  id: string,
  companyCode: CompanyCode,
) {
  await putJson(`/masterdata/companycodes/${id}`, companyCode)

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith('/masterdata/companycodes'.toLowerCase()),
  )
}

export async function requestDeleteCompanyCode(id: string) {
  await requestDelete(`/masterdata/companycodes/${id}`)

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith('/masterdata/companycodes'.toLowerCase()),
  )
}

export async function requestDeleteCompanyCodes(
  companyCodeIds: string[],
): Promise<any> {
  const result = await requestDeleteBatchWithBody(
    `/masterdata/companycodes/batch`,
    companyCodeIds,
  )

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith(`/masterdata/companycodes`.toLowerCase()),
  )

  return result
}

export async function requestDownloadCompanyCode(culture: string = 'DE-de') {
  const url = `/masterdata/companycodes/$download?csvCulture=${culture}`

  return await fetchFile(url)
}

export async function requestPrepareUploadableCompanyCodes(
  companyCodesCsv: File,
  culture: string,
): Promise<CompanyCode[]> {
  const formData = new FormData()
  formData.append('companyCodes', companyCodesCsv)

  const result = await postJson(
    `/masterdata/companycodes/batch/$preparecsv?csvCulture=${culture}`,
    formData,
  )

  return result as CompanyCode[]
}

export async function requestUploadCompanyCodes(
  companyCodes: CompanyCode[],
  deleteExistingCompanyCodes: boolean = false,
): Promise<void> {
  let query = `?deleteExistingCompanyCodes=${deleteExistingCompanyCodes.toString()}`

  const result = await postJson(
    `/masterdata/companycodes/batch${query}`,
    companyCodes,
  )

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith(`/masterdata/companycodes`.toLowerCase()),
  )

  return result
}

export async function requestCreateCompanyCodeCustomField(
  companyCodeId: string,
  customField: CompanyCodeCustomField,
) {
  await postJson(
    `/masterdata/companycodes/${companyCodeId}/customfields`,
    customField,
  )

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key
      .toLowerCase()
      .startsWith(
        `/masterdata/companycodes/${companyCodeId}/customfields`.toLowerCase(),
      ),
  )
}

export async function requestUpdateCompanyCodeCustomField(
  companyCodeId: string,
  customFieldId: string,
  customField: CompanyCodeCustomField,
) {
  await putJson(
    `/masterdata/companycodes/${companyCodeId}/customfields/${customFieldId}`,
    customField,
  )

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key
      .toLowerCase()
      .startsWith(
        `/masterdata/companycodes/${companyCodeId}/customfields`.toLowerCase(),
      ),
  )
}

export async function requestDeleteCompanyCodeCustomField(
  companyCodeId: string,
  customFieldId: string,
) {
  await requestDelete(
    `/masterdata/companycodes/${companyCodeId}/customfields/${customFieldId}`,
  )

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key.toLowerCase().startsWith('/masterdata/companycodes'.toLowerCase()),
  )
}
